import "./custom.css";
import "./styles.css";
// import { useCallback, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { CLOSE_ERROR } from "./app/calculatorSlice";
// import { UPLOAD_DB } from "./app/databaseSlice";
// import { UPLOAD_SETUPS } from "./app/setupsSlice";
// import { selectTab } from "./app/uiSlice";
// import Calculator from "./components/Calculator";
// import Importing from "./components/Canopy/Importing";
// import Intro from "./components/Canopy/Intro";
// import Outdates from "./components/Canopy/Outdates";
// import Modal from "./components/CommonCpns/Modal";
// import MyArtifacts from "./components/MyItemsDB/MyArtifacts";
// import MyWeapons from "./components/MyItemsDB/MyWeapons";
// import MyCharacters from "./components/MyCharacters";
// import MySetups from "./components/MySetups";
// import NavBar from "./components/NavBar";
// import adjustDB from "./helpers/adjustDB";
// import { Text } from "./styledCpns/DataDisplay";
// import { Button } from "./styledCpns/Inputs";
// import { AbsoluteBox, Box } from "./styledCpns/Layout";
import { TheEnd } from "./components/TheEnd";

// const tabContent = {
//   Characters: <MyCharacters />,
//   Weapons: <MyWeapons />,
//   Artifacts: <MyArtifacts />,
//   Setups: <MySetups />
// };

export default function App() {
  return (
    <div className="App">
      <TheEnd />
    </div>
  );
  // const tab = useSelector(selectTab);
  // const introOn = useSelector((state) => state.ui.introOn);
  // const importType = useSelector((state) => state.ui.importType);
  // const error = useSelector((state) => state.calculator.error);
  // const [outdates, setOutdates] = useState(null);
  // const dispatch = useDispatch();

  // const loadData = useCallback(
  //   (data) => {
  //     const [{ Setups, ...rest }, outdates] = adjustDB(data);
  //     dispatch(UPLOAD_DB(rest));
  //     dispatch(UPLOAD_SETUPS(Setups));
  //     if (outdates) setOutdates(outdates);
  //   },
  //   [dispatch]
  // );

  // useEffect(() => {
  //   const beforeunloadAlert = (e) => {
  //     e.preventDefault();
  //     return (e.returnValue = "Are you sure you want to exit?");
  //   };
  //   window.addEventListener("beforeunload", beforeunloadAlert, {
  //     capture: true
  //   });
  //   return () => {
  //     window.removeEventListener("beforeunload", beforeunloadAlert, {
  //       capture: true
  //     });
  //   };
  // }, []);

  // useEffect(() => {
  //   const data = localStorage.getItem("GDC_Data");
  //   if (data)
  //     try {
  //       loadData(JSON.parse(data));
  //     } catch (err) {
  //       console.log(err);
  //     }
  // }, [loadData]);

  // return (
  //   <div className="App flex-col">
  //     <NavBar loadData={loadData} outdates={outdates} />
  //     <div className="grow-1 flex-center relative">
  //       <Calculator />
  //       {tab in tabContent && (
  //         <AbsoluteBox top={0} left={0} zIndex={2} className="full-w full-h">
  //           {tabContent[tab]}
  //         </AbsoluteBox>
  //       )}
  //       {introOn && <Intro />}
  //       {importType ? <Importing /> : null}
  //       {outdates && (
  //         <Outdates outdates={outdates} close={() => setOutdates(null)} />
  //       )}
  //       {error && <Error />}
  //     </div>
  //   </div>
  // );
}

// function Error() {
//   const dispatch = useDispatch();
//   const close = () => dispatch(CLOSE_ERROR());
//   return (
//     <Modal close={close}>
//       <Box
//         className="p-4 flex-col white-glow-shadow"
//         width="20rem"
//         borderRadius="0.5rem"
//         bgColor="cardBg1"
//       >
//         <Text variant="h5" align="center" color="lightRed">
//           An Error has occurred and prevented the calculation process.
//         </Text>
//         <Button
//           className="mt-4 mx-auto glow-on-hover"
//           variant="positive"
//           onClick={close}
//         >
//           Confirm
//         </Button>
//       </Box>
//     </Modal>
//   );
// }
